/**
 * Tenant migration notice — hard migration overlay.
 *
 * Behaviour (see sprints/10migration/10migration.md):
 *  - Blocks the page: locks body scroll, traps focus on the CTA.
 *  - Hard migration: NO close button, NO "stay", Esc does not close,
 *    backdrop click does not close, NO sessionStorage snooze.
 *  - CTA navigates to migration_url (window.location.assign).
 *  - Auto-redirect: if data-redirect-secs > 0, count down then redirect.
 *  - A11y: focus lands on the CTA; reduced motion handled in CSS.
 *
 * All values come from data-attributes set in w_migration_notice.liquid,
 * so no metaobject field has to survive JSON serialization.
 */
(function () {
  'use strict';

  var root = document.getElementById('w-migration');
  if (!root) return;

  var url = root.getAttribute('data-migration-url');
  if (!url) return;

  var secs = parseInt(root.getAttribute('data-redirect-secs'), 10);
  if (isNaN(secs) || secs < 0) secs = 0;

  var cta = document.getElementById('w-migration-cta');
  var countdownEl = document.getElementById('w-migration-countdown');

  function redirect() {
    window.location.assign(url);
  }

  // Lock background scroll while the overlay is up.
  var prevOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';

  // Focus the only way forward.
  if (cta && typeof cta.focus === 'function') {
    cta.focus({ preventScroll: true });
  }

  // Focus trap: keep Tab/Shift+Tab inside the overlay; swallow Esc (hard migration).
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (e.key !== 'Tab') return;
    var focusable = root.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Auto-redirect countdown.
  if (secs > 0 && countdownEl) {
    var template = countdownEl.getAttribute('data-redirect-template') || '{{seconds}}';
    var remaining = secs;

    var render = function () {
      countdownEl.textContent = template.replace('%s', String(remaining));
    };
    render();

    var timer = window.setInterval(function () {
      remaining -= 1;
      if (remaining <= 0) {
        window.clearInterval(timer);
        redirect();
        return;
      }
      render();
    }, 1000);
  } else if (secs > 0) {
    window.setTimeout(redirect, secs * 1000);
  }

  // Restore scroll if the overlay is ever removed programmatically.
  window.addEventListener('pagehide', function () {
    document.body.style.overflow = prevOverflow;
  });
})();
